import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const AcceptedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon sx={{ width: '24px', height: '24px' }} {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="12" fill="#2E5C5F" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.625 17.125H16.25C16.7688 17.125 17.2125 16.8125 17.4 16.3625L19.2875 11.9562C19.3438 11.8125 19.375 11.6625 19.375 11.5V10.25C19.375 9.5625 18.8125 9 18.125 9H14.1812L14.775 6.14375L14.7937 5.94375C14.7937 5.6875 14.6875 5.45 14.5187 5.28125L13.8562 4.625L9.7375 8.74375C9.5125 8.96875 9.375 9.28125 9.375 9.625V15.875C9.375 16.5625 9.9375 17.125 10.625 17.125ZM10.625 9.625L13.3375 6.9125L12.5 10.25H18.125V11.5L16.25 15.875H10.625V9.625ZM5.625 9.625H8.125V17.125H5.625V9.625Z"
          fill="#19CAD7"
        />
      </svg>
    </SvgIcon>
  );
};

export default AcceptedIcon;
